<template>
    <div v-if="show" class="modal-detail">
        <el-dialog :visible.sync="show" title="name" width="900px" height="300px">
            <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
                <el-form-item prop="isExt" label="是否扩展字段">
                    <el-switch v-model="data.isExt" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item prop="name" label="字段名称">
                    <el-input v-model="data.name" placeholder="输入字段名称" type="text"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="字段编码">
                    <el-input v-model="data.code" placeholder="输入字段编码" type="text"></el-input>
                </el-form-item>
                <el-form-item prop="aliasCode" label="字段编辑编码" v-if="!data.isExt">
                    <el-input v-model="data.aliasCode" placeholder="输入字段编辑编码" type="text"></el-input>
                </el-form-item>
                <el-form-item prop="type" label="字段类型">
                    <el-select filterable default-first-option v-model="data.type" placeholder="选择字段类型"
                               @change="changeType" style="width: 100%">
                        <el-option :label="item.label" :value="item.value" v-for="(item, key) in dataList" :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="modularCode" label="关联模型" v-if="['many2one'].includes(data.type)">
                    <el-select filterable default-first-option v-model="data.modularCode" placeholder="选择关联模型"
                               style="width: 100%" @change="changeModularCode(true)">
                        <el-option :label="item.name" :value="item.code" v-for="(item, key) in modularList" :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="modularField" label="多对一展示字段" v-if="['many2one'].includes(data.type)">
                    <el-select filterable default-first-option v-model="data.modularField"
                               placeholder="选择多对一展示字段"
                               style="width: 100%">
                        <el-option :label="item.name" :value="item.code" v-for="(item, key) in modularFieldList"
                                   :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="customSql" label="公式" v-if="['sqlFormula'].includes(data.type)">
                    <el-input v-model="data.customSql" placeholder="输入公式" type="text"></el-input>
                </el-form-item>
                <el-form-item prop="sort" label="排序">
                    <el-input v-model="data.sort" placeholder="输入排序" type="number" class="no-number"
                              v-number></el-input>
                </el-form-item>
                <el-form-item prop="mobileType" label="显示类型">
                    <el-select filterable default-first-option v-model="data.mobileType" placeholder="选择显示类型"
                               style="width: 100%">
                        <el-option :label="item.label" :value="item.value" v-for="(item, key) in mobileTypeList"
                                   :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="isOrderBy" label="是否排序字段">
                    <el-switch v-model="data.isOrderBy" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item prop="orderByType" label="排序顺序" v-if="data.isOrderBy">
                    <el-select filterable default-first-option v-model="data.orderByType" placeholder="选择排序顺序"
                               style="width: 100%">
                        <el-option :label="item.label" :value="item.value" :key="key"
                                   v-for="(item, key) in [{value: 'asc', label: '正序'}, {value: 'desc', label: '倒序'}]">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="orderBySort" label="排序序号" v-if="data.isOrderBy">
                    <el-input v-model="data.orderBySort" placeholder="输入排序序号" type="number" class="no-number"
                              v-number></el-input>
                </el-form-item>
                <el-form-item prop="isGroupBy" label="是否分组字段">
                    <el-switch v-model="data.isGroupBy" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item prop="isSelect" label="是否作为后台查询条件">
                    <el-switch v-model="data.isSelect" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item prop="isSearch" label="是否搜索">
                    <el-switch v-model="data.isSearch" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
                <el-button @click="addItem" type="primary" size="mini" v-if="data.type === 'select'"
                           style="margin-bottom: 10px">增加选项
                </el-button>
                <div v-for="(item, index) in data.dicIds" :key="index">
                    <el-row v-if="data.type === 'select'">
                        <el-col :span="7">
                            <el-form-item label="name" :prop="'dicIds.' + index + '.name'"
                                          :rules="{required: true, message: '请输入name', trigger: 'blur'}">
                                <el-input v-model="item.name" style="width: 100px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="选项名称" :prop="'dicIds.' + index + '.label'"
                                          :rules="{required: true, message: '请输入选项名称', trigger: 'blur'}">
                                <el-input v-model="item.label" style="width: 100px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="排序号" :prop="'dicIds.' + index + '.sort'">
                                <el-input v-model="item.sort" type="number" class="no-number" v-number
                                          style="width: 100px">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-button style="font-size: 18px; color: #F56C6C" type="text" icon="el-icon-delete"
                                       @click="deleteItem(index)"></el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <template slot="footer">
                <div style="text-align: center">
                    <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            name: '',
            data: {},
            rules: {
                name: [{required: true, trigger: 'change', message: '输入字段名称'}],
                isExt: [{required: true, trigger: 'change', message: '选择是或否'}],
                code: [{required: true, trigger: 'change', message: '输入字段编码'}],
                aliasCode: [{required: true, trigger: 'change', message: '输入字段编辑编码'}],
                type: [{required: true, trigger: 'change', message: '选择字段类型'}],
                modularCode: [{required: true, trigger: 'change', message: '选择关联模型'}],
                customSql: [{required: true, trigger: 'change', message: '输入公式'}],
                sort: [{required: true, trigger: 'change', message: '输入排序'}],
                mobileType: [{required: true, trigger: 'change', message: '选择显示类型'}],
                isOrderBy: [{required: true, trigger: 'change', message: '选择是否排序字段'}],
                orderByType: [{required: true, trigger: 'change', message: '选择排序顺序'}],
                orderBySort: [{required: true, trigger: 'change', message: '输入排序序号'}],
                isGroupBy: [{required: true, trigger: 'change', message: '选择是否分组字段'}],
                isSelect: [{required: true, trigger: 'change', message: '选择是否作为后台查询条件'}],
                isSearch: [{required: true, trigger: 'change', message: '选择是否搜索'}],
                modularField: [{required: true, trigger: 'change', message: '选择多对一展示字段'}]
            },
            loading: false,
            isCreate: false,
            dataList: [
                {value: 'text', label: '文本'},
                {value: 'number', label: '数字'},
                {value: 'select', label: '单选'},
                {value: 'date', label: '日期'},
                {value: 'dateTime', label: '日期时间'},
                {value: 'boolean', label: '布尔'},
                {value: 'many2one', label: '多对一'},
                {value: 'fileUpload', label: '文件上传'},
                {value: 'imgUpload', label: '图片上传'},
                {value: 'sqlFormula', label: '后台公式'},
            ],
            modularList: [],
            modularFieldList: [],
            parentList: [],
            relationList: [],
            fieldList: [],
            mobileTypeList: [
                {value: 'all', label: '全部显示'},
                {value: 'pc', label: '电脑端显示'},
                {value: 'mobile', label: '手机端显示'},
                {value: 'off', label: '全部不显示'},
            ],
            row: {}
        }
    },
    methods: {
        display(data) {
            this.show = true
            this.data = data.data
            this.name = data.name
            this.row = data.row
            this.isCreate = data.isCreate
            this.getModularList()
        },

        getModularList() {
            const params = {
                params: {
                    pageNum: 1,
                    pageSize: 1000
                }
            }
            this.modularList = []
            this.$axios.get('/query/basicsModel/list', params).then(res => {
                res.data.data.list.forEach(item => {
                    if (item.code !== this.row.code) {
                        this.modularList.push(item)
                    }
                })
                if (this.data.type === 'many2one') {
                    this.changeModularCode(false)
                }
            })
        },

        changeModularCode(isChange) {
            const params = {
                params: {
                    pageNum: 1,
                    pageSize: 1000
                }
            }
            this.modularFieldList = []
            this.$axios.get(`/query/basicsFields/list/${this.data.modularCode}`, params).then(res => {
                res.data.data.list.forEach(item => {
                    if (item.type === 'text') {
                        this.modularFieldList.push(item)
                    }
                })
                if (isChange) {
                    this.$set(this.data, 'modularField', null)
                }
            })
        },

        addItem() {
            this.data.dicIds.push({
                name: '',
                label: '',
                sort: '',
            })
        },

        deleteItem(index) {
            this.data.dicIds.splice(index, 1)
        },

        changeType() {
            if (this.data.type !== 'many2one') {
                this.$set(this.data, 'modularCode', null)
            }
            if (this.data.type !== 'select') {
                this.$set(this.data, 'dicIds', [])
            }
        },

        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true
                    const params = JSON.parse(JSON.stringify(this.data))
                    if (params.isExt) {
                        params['aliasCode'] = params.code
                    }
                    this.dataList.forEach(item => {
                        if (item.id === this.data.dataId) params['dataName'] = item.name
                    })
                    const text = this.isCreate ? '创建' : '修改'
                    const url = this.isCreate ? '/query/basicsFields/save' : '/query/basicsFields/edit'
                    this.$axios.post(url, params).then(() => {
                        this.$message.success(`${text}成功`)
                        this.show = false
                        this.$emit('init')
                        this.loading = false
                    }).catch(err => {
                        console.log(`${text}失败`, err)
                        this.loading = false
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>
